import { Observable } from 'rxjs';
import { Link } from './content';
import { Product } from './product';

export enum HomeType {
  simple = 'nxtFrontpage',
  fancy = 'nxtFrontpageFancy',
  meny = 'nxtFrontpageMeny',
}

export interface ProductSection {
  title: string;
  products: Observable<Product[]>;
  link: Link;
}
